import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

function BulkProductReview() {
  const [text, setText] = useState('');
  const [summary, setSummary] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();
    // Simulate parsing CSV/text and producing a summary report
    const lines = text.split(/\r?\n/).filter(Boolean);
    setSummary({ total: lines.length, approved: Math.floor(lines.length * 0.6), rejected: Math.ceil(lines.length * 0.4) });
  }

  return (
    <>
      <Helmet><title>Bulk Product Review | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Bulk Product Review</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e)=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Products</p>
            </div>
          </div>
          <div className="card card-default">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Paste SKUs (one per line) or CSV</label>
                  <textarea className="form-control" rows={10} value={text} onChange={(e) => setText(e.target.value)} placeholder="SKU-1\nSKU-2\nSKU-3" />
                </div>
                <div className="d-flex gap-2">
                  <button type="submit" className="btn btn-primary">Review</button>
                  <button type="button" className="btn btn-secondary" onClick={() => { setText(''); setSummary(null); }}>Clear</button>
                </div>
              </form>
              {summary && (
                <div className="mt-4">
                  <h5>Summary</h5>
                  <ul>
                    <li>Total: {summary.total}</li>
                    <li>Approved: {summary.approved}</li>
                    <li>Rejected: {summary.rejected}</li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BulkProductReview;
